import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss']
})
export class DropzoneComponent implements OnInit {


  files = [];

  @Input() limite;
  @Output() retornaFiles = new EventEmitter<any[]>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {

  }

  onRemove(f) {
    this.files.splice(this.files.indexOf(f), 1);
  }

  onSelect(event) {
    if(this.limite != null){
      if(this.files.length == this.limite){
        this.files.splice(this.files.length-1, 1);
      }
    }

    for (const iterator of event.addedFiles) {
      const reader = new FileReader();
      reader.readAsDataURL(iterator);
      reader.onload = () => {
        let base64 = String(reader.result);
        iterator.base64 = base64.split(',')[1];
        iterator.nombre = iterator.name;
        iterator.tipo = iterator.type;
        this.files.push(iterator);
      };
    }
  }

  cancelar() {
    this.files = [];
    this.activeModal.dismiss();
  }

  confirmar() {
    this.retornaFiles.emit(this.files);
    this.activeModal.dismiss();
  }
}
